import React from "react";
import { useNavigate } from "react-router-dom";
import Modal from "react-modal";
import { useState, useEffect } from "react";
import SearchBar from "../components/SearchBar";
import Button1 from "../components/Button1";
import { ReactComponent as CloseIcon } from "../icons/close.svg";
import { ReactComponent as EditIcon } from "../icons/edit.svg";
import DataTable from "react-data-table-component";
import { adminServices } from "../services/AdminServices";
import ConfirmationDialog from "../components/ConfirmationDialog";
import AlertModal from "../components/AlertModal";
import LoadingModal from "../components/LoadingModal";
import { ReactComponent as TransactionIcon } from "../icons/merchant.svg";
import MerchantFormComponent from "../components/merchants/MerchantForm";
import UnauthorizedComponent from "../components/UnauthorizedComponent";
import withAuthorization from "../components/withAuthorization";
import { formatCurrency } from "../tools/tool";
import CategoryComponent from "../components/services/Categories";
import { toast } from "react-toastify";
const MerchantPage = () => {
  const [kioskSales, setKioskSales] = useState([]);
  const [data, setData] = useState([]);
  // const [columns, setColumns] = useState([]);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [showAlert, setShowAlert] = useState(false);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [showFormModal, setShowFormModal] = useState(false);
  const [selectedData, setSelectedData] = useState(null);
  const [showError, setShowError] = useState(false);
  const [message, setMessage] = useState("");
  let columns = [{
    name: 'Date Registered',
    selector: data => new Date(data.reg_date).toLocaleString(),
    sortable: true
  }, {
    name: 'PDL Number',
    selector: data => data.pdl_number,
    sortable: true
  }, {
    name: 'PDL Name',
    selector: data => data.first_name + " " + data.last_name,
    sortable: true
  }, {
    name: 'Merchant Name',
    selector: data => data.merchant_name,
    sortable: true
  }, {
    name: 'Store Code',
    selector: data => data.merchant_code || data.merchantCode || '',
    sortable: true
  }, {
    name: 'Description',
    selector: row => {
      const d = row.description || "";
      const max = 60;
      const truncated = d.length > max ? d.substring(0, max) + '...' : d;
      return <span title={d} style={{
        display: 'inline-block',
        maxWidth: '360px',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap'
      }}>
            {truncated}
          </span>;
    },
    sortable: true
  }, {
    name: 'Type',
    selector: data => data.type,
    sortable: true
  }, {
    name: 'Location',
    selector: data => data.location,
    sortable: true,
    right: false
  }, {
    name: 'Wallet',
    selector: data => formatCurrency(data.wallet_amount),
    sortable: true,
    right: true
  }, {
    name: 'Status',
    selector: data => data.status == 1 ? "Active" : "Inactive",
    sortable: true
  }, {
    name: 'Action',
    right: true,
    selector: row => row.type === 'Store' ? <div> <button type="button" onClick={() => handleEditClick(row)} style={{
        marginLeft: '10px'
      }}>Edit</button> </div> : <div><button type="button" onClick={() => handleEditClick(row)} style={{
        marginLeft: '10px'
      }}>Edit</button></div>
  }];

  //modal function
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [selectedMerchant, setSelectedMerchant] = useState(null);
  const openViewMerchantModal = merchant => {
    setSelectedMerchant(merchant);
    setModalIsOpen(true);
  };
  const closeViewMerchantModal = () => {
    setModalIsOpen(false);
    setSelectedMerchant(null);
  };
  const handleButtonClick = r => {
    setShowAlert(true);
    setSelectedMerchant(r);
  };

  //search function
  const [searchTerm, setSearchTerm] = useState("");
  const [displayedProducts, setDisplayedProducts] = useState([]);
  useEffect(() => {
    setLoading(true);
    getPadala();
  }, []);

  // setTimeout(()=>{
  //   getPadala();
  // },60000);

  const handleEditClick = r => {
    navigate("/merchant/edit/" + r.id);
  };
  const customStyles = {
    headCells: {
      style: {
        fontWeight: 'bold'
      }
    },
    cells: {
      style: {
        wordBreak: 'break-word',
        whiteSpace: 'normal'
      }
    }
  };
  // ensure table layout is fixed to avoid horizontal scrolling
  customStyles.table = {
    style: {
      tableLayout: 'fixed'
    }
  };
  const getPadala = () => {
    adminServices.storeProcedure2('pdl_merchants', {}).then(r => {
      setKioskSales(null);
      setKioskSales(r.data);
      setData(r.data);
      setFilteredData(r.data);

      // var _col = 

      // setColumns(_col);
      setLoading(false);
    }).catch(e => {
      if (e.status == 401) {
        window.location.href = "/";
      }
      if (e.status == 429) {
        toast.error("Too many requests. Please refresh after this notification has closed automatically.", {
          autoClose: 60000
        });
      }
    });
  };
  const handleRowClick = row => {
    var mid = btoa(JSON.stringify(row));
    localStorage.setItem("selectedMerchant", mid);
    navigate("/merchant-transactions");
  };

  //pagination
  const [currentPage, setCurrentPage] = useState(1);
  const [merchantsPerPage, setMerchantsPerPage] = useState(10);

  // Get current merchants
  const indexOfLastProduct = currentPage * merchantsPerPage;
  const indexOfFirstProduct = indexOfLastProduct - merchantsPerPage;
  const currentProducts = displayedProducts.slice(indexOfFirstProduct, indexOfLastProduct);

  // Change page
  const paginate = pageNumber => setCurrentPage(pageNumber);
  return <div className="container ">
      <MerchantFormComponent show={showFormModal} data={selectedData} onClose={() => {
      setShowFormModal(false);
      setSelectedData(null);
    }} onAfterSubmit={() => {
      setSelectedData(null);
      setMessage("Merchant saved successfully");
      setShowError(true);
      getPadala();
    }} onError={() => {
      setMessage("Error saving supplier");
      setShowError(true);
    }} />
      <LoadingModal show={loading} message={"Loading Merchants..."} />
      <AlertModal show={showAlert} title={selectedMerchant && selectedMerchant.merchant_name + " - " + selectedMerchant.username} message={"Merchant Password is: " + (selectedMerchant && selectedMerchant.password) + ""} onClose={() => {
      setShowAlert(false);
      setSelectedMerchant(null);
    }} />
      <AlertModal show={showError} title={"Merchant Management"} message={message} onClose={() => {
      setShowError(false);
    }} />

      {/* View merchant details modal */}
      
      {/* Header */}
      <div style={{
      fontSize: '1.5rem',
      fontWeight: 'bold',
      marginBottom: 10,
      display: 'flex',
      justifyContent: 'start',
      alignItems: 'center'
    }}>
          <TransactionIcon style={{
        width: "50px",
        height: "50px",
        marginRight: "10px",
        background: 'transparent'
      }} />
          Merchants
      </div>

      <div style={{
      height: "25px"
    }}></div>

      {/* Search Row */}
      <div className="flexRow">
        <div className="flexRow filterDiv">
          <SearchBar placeholder="Search Merchants" onChange={e => {
          const value = e.target.value.toLowerCase();
          const filtered = data.filter(item => Object.keys(item).some(key => item[key] && item[key].toString().toLowerCase().includes(value.toLowerCase())));
          setFilteredData(filtered);
        }} />
        </div>
        &nbsp;&nbsp;
        <div style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "flex-end"
      }}>
        </div>
        <div className="spacer"></div>
        <div>
          
          <Button1 text={"Add merchant"} onClick={() => {
          navigate("/merchant/add");
        }} />
        </div>
      </div>

      

      <div style={{
      height: "25px"
    }}></div>


      {/* Table */}
      <div className="merchantTableContainer">
        <DataTable customStyles={customStyles} responsive columns={columns} data={filteredData} pagination={false} highlightOnHover striped style={{
        zIndex: 0
      }} onRowClicked={handleRowClick} defaultSortFieldId={0} defaultSortAsc={false} />
      </div>

      {/* <div style={{ height: "10px" }}></div> */}

      {/* Table Footer */}
      
          
      {/*  */}
    </div>;
};
export default withAuthorization(MerchantPage, 13);